import React from "react";
import ClienConsent from "../../assets/pdfs/downloads/Client_Consent_Form-Cells.pdf";
import Naasbestaandes from "../../assets/pdfs/downloads/Gids-vir-die-Naasbestaandes_29Jun2017.pdf";
import Prospectus from "../../assets/pdfs/downloads/SPEKTRA_PROSPECTUS_optimize.pdf";
import Prospektus from "../../assets/pdfs/downloads/SPEKTRA_PROSPEKTUS_optimiseer.pdf";
import Guid from "../../assets/pdfs/downloads/THE-GUIDE-FOR-THE-BEREAVED.pdf";
import { FooterLink } from "..";

export const FooterLinks: React.FC = React.memo(() => (
  <div className="footer__container__links">
    <div className="footer__container__links--container">
      <FooterLink
        title="Discover:"
        links={[
          {
            link: "/",
            name: "Home",
          },
          {
            link: "/about",
            name: "About",
          },
          {
            link: "/services",
            name: "Services",
          },
          {
            href: "https://prispek.co.za/prispek-blogs/",
            name: "Blogs",
          },
          {
            link: "/contact",
            name: "Contact",
          },
          {
            link: "/login",
            name: "Staff Login",
          },
        ]}
      />
      <FooterLink
        title="Socials:"
        links={[
          {
            href: "https://www.facebook.com/prispek/?__cft__[0]=AZXSkPvyFidepsOXZy5IMZCpsR3rOAZk8H4LNMkRNJ-UYmSj0ghB_uMU-o5iqIbZap4fe4rII_1-vR1LZPLp4XdleJ4121NkpGiwMeCslJjd3F35M_AaVxA4vVSmcSi6NXPtdRPu1COEnN6me4oFOuvM&__tn__=%3C%3C%2CP-R",
            name: "Facebook",
          },
          // {
          //   href: '/',
          //   name: 'Instagram'
          // },
          // {
          //   href: '/',
          //   name: 'Linkedin'
          // }
        ]}
      />
    </div>
    <div className="footer__container__links--container">
      <FooterLink
        title="Downloads:"
        links={[
          {
            href: Prospektus,
            name: "Spektra Prospektus (Afrikaans)",
          },
          {
            href: Prospectus,
            name: "Spektra Prospektus (English)",
          },
        ]}
      />
      <FooterLink
        last
        title="Important downloads:"
        links={[
          {
            href: ClienConsent,
            name: "Client Consent Form",
          },
          {
            href: Naasbestaandes,
            name: "Gids vir die Naasbestaandes",
          },
          {
            href: Guid,
            name: "The Guide for the Bereaved",
          },
        ]}
      />
    </div>
  </div>
));
